import { render, staticRenderFns } from "./NewStoreFooter.vue?vue&type=template&id=9a3d45b2&scoped=true"
import script from "./NewStoreFooter.vue?vue&type=script&lang=js"
export * from "./NewStoreFooter.vue?vue&type=script&lang=js"
import style0 from "./NewStoreFooter.vue?vue&type=style&index=0&id=9a3d45b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a3d45b2",
  null
  
)

export default component.exports